import { render } from "./ModalInputEmail.vue?vue&type=template&id=88596a40"
import script from "./ModalInputEmail.vue?vue&type=script&lang=js"
export * from "./ModalInputEmail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__